import { FC } from "react";
import { SystemProducts } from "../../modules/system";

interface Props {
  siteId: number;
}

export const System: FC<Props> = ({ siteId }) => {
  return (
    <div>
      <SystemProducts siteId={siteId} />
    </div>
  );
};
